window.initLazyImages = function(root = document) {

    const images = root.querySelectorAll("img[data-src]");

    if (!('IntersectionObserver' in window)) {
        images.forEach(img => {

            const src = img.dataset.src;

            if (!src || src === "undefined") return;

            img.src = src;
            img.removeAttribute("data-src");
        });

        return;
    }

    const observer = new IntersectionObserver((entries, obs) => {

        entries.forEach(entry => {

            if (!entry.isIntersecting) return;

            const img = entry.target;
            const src = img.dataset.src;

            if (!src || src === "undefined") {
                obs.unobserve(img);
                return;
            }

            const newImg = new Image();

            newImg.onload = () => {
                img.src = src;
                img.removeAttribute("data-src");
                obs.unobserve(img);
            };

            newImg.src = src;

        });

    }, {
        rootMargin: "150px 0px",
        threshold: 0.01
    });

    images.forEach(img => observer.observe(img));
};

document.addEventListener("DOMContentLoaded", () => {
    window.initLazyImages();
});

document.addEventListener("shopify:section:load", (e) => {
    window.initLazyImages(e.target);
});